/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Types.QueryOrderEnum>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  status?: Types.InputMaybe<Types.EscrowStatusFilterEnum>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  escrowParty?: Types.InputMaybe<Types.EscrowPartyTypeEnum>;
}>;

export type ISoftwareEscrowsQuery = {
  __typename?: 'Query';
  softwareEscrows: {
    __typename?: 'SoftwareEscrowPage';
    nodesCount: number;
    pagesCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    nodes: Array<{
      __typename?: 'SoftwareEscrow';
      id: string;
      currentCompanyRole?: Types.EscrowPartyTypeEnum | null;
      changesRequested: boolean;
      startedBy: Types.EscrowPartyTypeEnum;
      depositStatus: Types.DepositStatusEnum;
      status: Types.EscrowStatusEnum;
      createdAt: any;
      adminReviewAt?: any | null;
      onboardingAt?: any | null;
      signedAt?: any | null;
      activatedAt?: any | null;
      certificationVerified: boolean;
      certificationCertified: boolean;
      lastDeposit?: any | null;
      userUpdatedAt: any;
      pendingActivation: boolean;
      agreement: {
        __typename?: 'Agreement';
        id: string;
        approved: boolean;
        approvedByBeneficiary?: boolean | null;
        approvedByDepositor?: boolean | null;
        approvedByCodekeeper?: boolean | null;
        agreementForm?: Types.AgreementFormEnum | null;
        policy: { __typename?: 'AgreementPolicy'; approve: boolean };
      };
      escrowInvitation?: {
        __typename?: 'EscrowInvitation';
        status: Types.InvitationStatusEnum;
        companyName: string;
        id: string;
        partyType: string;
        userName: string;
        userEmail: string;
        user?: { __typename?: 'User'; id: string; name?: string | null; email: string; phone?: string | null } | null;
        policy: { __typename?: 'EscrowInvitationPolicy'; accept: boolean; reject: boolean; update: boolean };
        escrow:
          | { __typename?: 'ContinuityEscrow'; id: string }
          | { __typename?: 'SaasEscrow'; id: string }
          | { __typename?: 'SoftwareEscrow'; id: string };
      } | null;
      escrowTermination?: {
        __typename?: 'EscrowTermination';
        status: Types.EscrowTerminationStatusEnum;
        terminateAt?: any | null;
      } | null;
      beneficiary?: {
        __typename?: 'Beneficiary';
        id: string;
        companyName?: string | null;
        companyWebsite?: string | null;
      } | null;
      depositor?: {
        __typename?: 'Depositor';
        id: string;
        companyName?: string | null;
        companyWebsite?: string | null;
      } | null;
      policy: { __typename?: 'SoftwareEscrowPolicy'; remove: boolean };
    }>;
  };
};

export const SoftwareEscrowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'softwareEscrows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryOrderEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowStatusFilterEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParty' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowPartyTypeEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'softwareEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowParty' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParty' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentCompanyRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'changesRequested' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvedByBeneficiary' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvedByDepositor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvedByCodekeeper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'approve' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowInvitation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'escrow' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowInvitation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowInvitationFields' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowTermination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'terminateAt' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adminReviewAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onboardingAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastDeposit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userUpdatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingActivation' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowInvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowInvitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISoftwareEscrowsQuery, ISoftwareEscrowsQueryVariables>;
